import { CobranzasAxios, COMPANY } from './config'

export const getCompanies = async () => {
  const res = await CobranzasAxios.get('/company')
  return res.data
}

export const postCompanies = async (data) => {
  const res = await CobranzasAxios.post('/company', data)
  return res.data
}

export const putCompanies = async (data, id) => {
  const res = await CobranzasAxios.put(`/company/${id}`, data)
  return res.data
}

export const putCompaniesConfig = async (data) => {
  const res = await CobranzasAxios.put(`/company/settings/${COMPANY}`, data)
  return res.data
}
